module.exports = __webpack_public_path__ + "img/y-220.90db4aa2.png";